export default __webpack_public_path__ + "static/media/gallery_02.64504e1c.jpg";